import { useQuery } from "@tanstack/react-query";
import { usePublicClient } from "wagmi";
import { GATEWAY_ABI } from "@/contract/abi/gateway";
import ContractAddress from "@/contract/addresses";
import { useEffectiveAddress } from "@/hooks/auth/useEffectiveAddress";
import { useFetchMe } from "./useFetchMe";

export type UseFetchOrderBehindReturn = ReturnType<typeof useFetchOrderBehind>;

export const useFetchOrderBehind = () => {
  const address = useEffectiveAddress();
  const publicClient = usePublicClient();
  const me = useFetchMe();

  return useQuery({
    queryKey: ["order-behind", address, me.isLoading],
    queryFn: async () => {
      if (!publicClient) return 0;

      const userFromContract = await publicClient.readContract({
        abi: GATEWAY_ABI,
        address: ContractAddress.GATEWAY,
        functionName: "getUser",
        args: [address as `0x${string}`],
      });

      const lastUserOrderId = Number(userFromContract.last_order.order_id);
      const lastOrderId = await publicClient.readContract({
        abi: GATEWAY_ABI,
        address: ContractAddress.GATEWAY,
        functionName: "order_id",
      });

      const list = me.data?.pending_orders_list.map((s) => Number(s));
      list?.sort((a, b) => a - b);
      const firstOrder = (list || [0])[0];

      if (
        lastUserOrderId === 0 &&
        me.data?.pending_orders_list?.length &&
        firstOrder > 0
      ) {
        return Math.ceil((Number(firstOrder) - lastUserOrderId) / 35);
      }

      return Math.ceil((Number(lastOrderId) - lastUserOrderId) / 35);
    },
    enabled: !!address,
  });
};
